import React, { useEffect } from 'react';
import { useToast } from '../../context/ToastContext';
import { FEATURE_DISPLAY_NAMES } from '../../types/features';
import type { FeatureName } from '../../types/features';

/**
 * Écoute l'événement DOM "feature-blocked" dispatché par l'intercepteur axios
 * et affiche un toast informatif.
 * Doit être rendu à l'intérieur du ToastProvider.
 */
const FeatureBlockedListener: React.FC = () => {
  const { warning } = useToast();

  useEffect(() => {
    const handler = (e: CustomEvent) => {
      const { feature, current_plan } = e.detail ?? {};
      const featureName = feature
        ? (FEATURE_DISPLAY_NAMES[feature as FeatureName] ?? feature)
        : 'cette fonctionnalité';
      const planLabel = current_plan
        ? current_plan.charAt(0).toUpperCase() + current_plan.slice(1)
        : 'votre plan actuel';

      warning(
        `"${featureName}" n'est pas disponible avec le plan ${planLabel}. Passez à un plan supérieur.`,
        6000
      );
    };

    window.addEventListener('feature-blocked', handler as EventListener);
    return () => window.removeEventListener('feature-blocked', handler as EventListener);
  }, [warning]);

  return null;
};

export default FeatureBlockedListener;
